import {
  Dialog,
  DialogContent,
  Button,
  IconButton,
  Typography,
  AppBar,
  Stack,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormikContext } from "formik";
import { CustomTitle, getFilteredData, Loader } from "../HelperFunctions/HelperFunctions";
import { getCorporationsByMgntGrp, getManagementGroupsList } from "../API/nimbleAPI";
import { useEffect, useState } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { enqueueSnackbar } from "notistack";
import { useLoaderData } from "react-router-dom";

const CorporationSelectDialog = ({ open, onClose, corpCount }) => {
  const { token, clientID, UID } = useLoaderData()
  const columns = [
    { name: "corporation_name_DBA_name", dataKey: "CorporationName", width: "120px" },
    { name: "legal_name", dataKey: "LegalName", width: "120px" },
    { name: "property_type", dataKey: "PropertyType", width: "110px" },
    { name: "service", dataKey: "Service", width: "110px" },
    { name: "brand", dataKey: "Brand", width: "65px" },
    { name: "pms", dataKey: "PMS", width: "80px" },
  ];

  const { values, handleChange, setFieldValue } = useFormikContext();
  const [loading, setLoading] = useState(false);
  const [corpTableData, setCorpTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [managementGroup, setManagementGroup] = useState([]);


  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedManagementGroup, setSelectedManagementGroup] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [corporationCount, setCorporationCount] = useState(false);

  useEffect(() => {
    managementGroupData();
  }, []);

  useEffect(() => {
    if (selectedManagementGroup) {
      getCorporation();
    }
  }, [selectedManagementGroup]);

  useEffect(() => {
    if (open) {
      setSelectedRows(values.selected_corporations || []);
      setSelectedManagementGroup(values.corp_management_groups || "");
    }
  }, [open, values.selected_corporations, values.corp_management_groups]);


  const handleApply = () => {
    setFieldValue("selected_corporations", selectedRows);
    setFieldValue("cropCount", corporationCount);
    corpCount(corporationCount)
    setFieldValue("corp_management_groups", selectedManagementGroup);
    setFieldValue("users", []);
    setFieldValue("users_info", []);
    onClose();
  };


  const managementGroupData = async () => {
    setLoading(true);
    try {
      const data = await getManagementGroupsList();
      // setManagementGroup(data)
      if (data.status == 200) {
        const grpData = await data.json()
        setManagementGroup(grpData);
      } else {
        enqueueSnackbar("Error while getting Management ", { variant: "error" })
        // onClose()
      }
    } catch (error) {
      enqueueSnackbar("Error while getting Corporations", { variant: "error" })
    } finally {
      setLoading(false);
    }


  };

  const getCorporation = async () => {
    setLoading(true);
    try {

      const corporations = await getCorporationsByMgntGrp(selectedManagementGroup);
      const corporationIds = corporations.map(item => item.CorporationID);
      setCorporationCount(corporationIds.length)
      // corpCount(corporationIds.length)

      setCorpTableData(corporations);
      setOriginalData(corporations);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      enqueueSnackbar("Error while getting corporation details", {
        variant: "error",
      });
    }
  };



  const handleCheckboxChange = (checked, corporationId) => {
    const newSelected = checked
      ? [...selectedRows, corporationId]
      : selectedRows.filter((id) => id !== corporationId);
    setSelectedRows(newSelected);
  };

  const handleSelectAll = (checked) => {
    const newSelected = checked
      ? corpTableData.map((row) => row.CorporationID)
      : [];
    setSelectedRows(newSelected);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    const filtered = getFilteredData(value, originalData);
    setCorpTableData(filtered);
  };


  const TableComponents = {
    Table: (props) => (
      <Table
        {...props}
        style={{
          borderCollapse: "separate",
          tableLayout: "fixed",
        }}
      />
    ),
    TableHead,
    TableRow,
    TableBody,
  };

  const fixedHeaderContent = () => (
    <TableRow sx={{ bgcolor: "#d7d7d7" }}>
      <TableCell
        // width="1px"
        // sx={{ padding: "1px", borderRight: "1px solid white" }}
        width="40px" // Give enough space
        sx={{
          padding: "1px",
          borderRight: "1px solid white",
          minWidth: "30px",
          maxWidth: "30px",
        }}
      >
        {/* <Checkbox size="small" color="grey" disableRipple /> */}
        <Checkbox
          size="small"
          color="grey"
          disableRipple
          checked={corpTableData.length > 0 && selectedRows.length === corpTableData.length}
          indeterminate={selectedRows.length > 0 && selectedRows.length < corpTableData.length}
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      </TableCell>
      {columns.map((column, index) => (
        <TableCell
          key={index}
          width={column.width}
          sx={{
            borderRight: "1px solid white",
            padding: 1,
            fontSize: "13px",
            fontWeight: 500,
          }}
        >
          {column.name === "pms" ? "PMS" : CustomTitle(column.name)}
        </TableCell>
      ))}
    </TableRow>
  );

  const itemContent = (index) => {
    const row = corpTableData[index];
    return (
      <>
        <TableCell sx={{ padding: "1px", borderRight: "1px solid #f2f2f2" }}>
          {/* <Checkbox
            size="small"
            color="grey"
            disableRipple
            values={values.selected_corporations || ""}
            checked={values.selected_corporations.includes(
              row.CorporationID
            )}
            onChange={(e) =>
              handleCheckboxChange(e.target.checked, row.CorporationID)
            }
          /> */}
          <Checkbox
            size="small"
            color="grey"
            disableRipple
            checked={selectedRows.includes(row.CorporationID)}
            onChange={(e) => handleCheckboxChange(e.target.checked, row.CorporationID)}
          />
        </TableCell>
        {columns.slice(0, 7).map((column, colIndex) => (
          <TableCell
            key={colIndex}
            sx={{
              borderRight: "1px solid #f2f2f2",
              padding: "10px",
              fontSize: "12px",
              maxWidth: column.width,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Tooltip title={row[column.dataKey] || "-"} arrow>
              <span>{row[column.dataKey] || "-"}</span>
            </Tooltip>
          </TableCell>
        ))}
      </>
    );
  };



  return (
    <Dialog open={open} fullScreen>
      <AppBar
        sx={{ position: "relative", bgcolor: "#d7d7d7", height: 45 }}
        elevation={0}
      >
        <Box sx={{ height: 45, alignContent: "center", padding: "0 15px" }}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Stack direction={"row"}>
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                // onClick={handleCorporationClose}
                onClick={onClose}
                aria-label="close"
                style={{ backgroundColor: "#686868" }}
                disableRipple
              >
                <CloseIcon sx={{ fontSize: "15px" }} />
              </IconButton>
              <Typography
                sx={{
                  ml: 2,
                  flexGrow: 10, // Pushes buttons to the right
                  color: "#1f1f1f",
                }}
                component="div"
                fontWeight={600}
                fontSize={"15px"}
              >
                Corporation Selection
              </Typography>
            </Stack>
            <Stack direction={"row"} gap={3}>
              <Button
                variant="contained"
                size="small"
                disableElevation
                disableRipple
                sx={{
                  px: 4,
                  textTransform: "none",
                  backgroundColor: "#b5dcf2",
                  color: "#000",
                  fontWeight: 400,
                }}
                onClick={handleApply}
              >
                Apply
              </Button>
            </Stack>
          </Stack>
        </Box>
      </AppBar>
      <DialogContent
        sx={{
          padding: 1,
        }}
      >
        <Stack gap={2} height={"100%"} direction={"column"}>
          <Stack direction={"row"} gap={2}>

            <Autocomplete
              size="small"
              sx={{ minWidth: 250, maxWidth: 250, m: 1 }}
              options={managementGroup}
              getOptionLabel={(option) => option?.DisplayText || ""}
              isOptionEqualToValue={(option, value) => option?.ValueCode === value?.ValueCode}
              value={
                selectedManagementGroup === "ALL"
                  ? { ValueCode: "ALL", DisplayText: "--ALL--" }
                  : managementGroup.find(opt => opt.ValueCode === selectedManagementGroup) || null
              }
              disableClearable
              onChange={(event, newValue) => {
                const skipValues = ["PropertyType", "BrandName", "Portfolio", "Region", "ServiceType"];
                if (newValue && skipValues.includes(newValue.ValueCode)) {
                  setSelectedManagementGroup("ALL");
                } else {
                  setSelectedManagementGroup(newValue?.ValueCode || "");
                }
                setSelectedRows([]);
                setSearchTerm("");
                setCorporationCount(false)
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Management Groups"
                  inputProps={{ ...params.inputProps, readOnly: true }}
                  InputProps={{
                    ...params.InputProps,
                    sx: { fontSize: "13px", fontWeight: 500 },
                  }}
                  InputLabelProps={{
                    sx: { fontSize: "12px" },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.ValueCode} style={{ fontSize: "13px", fontWeight: 500 }}>
                  {option.DisplayText}
                </li>
              )}
            />

            <TextField
              sx={{
                mt: 1,
                minWidth: 220,
                backgroundColor: "transparent",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "transparent",
                  maxHeight: "33px",
                  fontSize: "13px",
                  bgcolor: "#f5f5f5",
                  fontWeight: 500,
                  cursor: "pointer",
                },
                "& .MuiOutlinedInput-input": {
                  cursor: "pointer",
                },
              }}
              size="small"
              label="Corporation"
              name="corporation"
              value={
                selectedRows.length === corporationCount && corporationCount > 0 ? "All_corporation(s)selected"
                  :
                  selectedRows.length > 9
                    ? `${selectedRows.length}_corporation(s)selected`
                    : selectedRows.length > 0
                      ? `0${selectedRows.length}_corporation(s)selected`
                      : "00_corporation(s)selected"
              }
              InputProps={{ readOnly: true }}
            />


            <TextField
              size='small'
              placeholder='Search'
              sx={{
                mt: 1,
                minWidth: 300,
                backgroundColor: "transparent",
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "transparent",
                  maxHeight: "33px",
                  fontSize: "13px",
                  bgcolor: "#f5f5f5",
                  fontWeight: 500,
                },
              }}
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Stack>

          <Box
            height={"100%"}
            border={"1px solid #d7d7d7"}
          // overflow={"auto"}
          >
            <TableVirtuoso
              style={{ height: "570px" }}
              data={corpTableData}
              components={TableComponents}
              fixedHeaderContent={fixedHeaderContent}
              itemContent={itemContent}
            />
          </Box>
        </Stack>
      </DialogContent>
      <Loader loading={loading} />
    </Dialog>
  );
};

export default CorporationSelectDialog;
